import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <div className="flex flex-wrap gap-2 mb-8">
      <button
        onClick={() => onCategoryChange('all')}
        className={`inline-flex items-center px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
          activeCategory === 'all'
            ? 'bg-blue-600 text-white border border-blue-600 shadow-md'
            : 'bg-white text-gray-700 hover:bg-blue-50 border border-gray-300 hover:border-blue-300'
        }`}
      >
        <Icon name="Grid3X3" size={16} className="mr-2" />
        All Insights
      </button>

      {categories.map((category) => (
        <button
          key={category.id}
          onClick={() => onCategoryChange(category.id)}
          className={`inline-flex items-center px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
            activeCategory === category.id
              ? 'bg-blue-600 text-white border border-blue-600 shadow-md'
              : 'bg-white text-gray-700 hover:bg-blue-50 border border-gray-300 hover:border-blue-300'
          }`}
        >
          <Icon name={category.icon} size={16} className="mr-2" />
          {category.name}
          <span className="ml-2 px-2 py-0.5 bg-gray-100 text-gray-600 text-xs rounded-full">
            {category.count}
          </span>
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;